<template lang="pug">
    el-popover(
        placement="top-start" width="640" trigger="click"
        @show="() => { isShow = true; $emit('show') }"
        @hide="() => { isShow = false; }"
    )
        .date-device
            .data-none(v-if="!list || list.length == 0" style="margin-top: 10px;") 暂无数据
            //- .ctn
            .tableBox(v-for="(item, i) in list")
                span.fl(
                    :style="{ height: item.value.length * 30 + 'px', lineHeight: item.value.length * 30 + 'px', width: '100px' }"
                ) {{item.build}}
                .fl(v-for="(it, j) in item.value" style="width: calc(100% - 102px)")
                    span(style="width: 100px;line-height: 30px;") {{it.unit}}
                    .item {{it.elevatorNos ? it.elevatorNos.join(',') : ''}}(已选)
        .detail_de(slot="reference" :class="{'active': isShow}")
            span {{data.targetDate}}
            .fr
                | ¥{{data.slotAmount}}
                i.iconfont.icon-wodedingdan-xiaoqu-zhankaiicon
</template>

<script>
export default {
    name: 'DateDeviceItem',
    props: ['data', 'idx'],
    data () {
        return {
            list: [],
            isShow: false
        }
    },
    watch: {
        data: {
            immediate: true,
            deep: true,
            handler (v) {
                if (v && v.nhbdDeviceInfo) this.list = v.nhbdDeviceInfo
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.detail_de
    width: 200px
    height: 40px
    color: #666666
    background: #F5F5F5
    border-radius: 2px
    padding: 10px
    float: left
    margin: 5px
    &.active
        border: 1px solid #6296FF
        background: #fff
    i
        margin-left: 10px
    span
        color: #282729
        font-weight: 500
        font-size: 14px
.tableBox
    overflow: hidden
    border: 1px solid #E9E9E9
    border-top: none
    &:first-child
        border-top: 1px solid #E9E9E9
    .fl
        overflow: hidden
        > span, > div
            float: left
    span
        display: inline-block
        height: 30px
        width: 100%
        border-right: 1px solid #E9E9E9
        text-align: center
    .item
        display: inline-block
        width: calc(100% - 102px)
        height: 30px
        line-height: 30px
        padding-left: 20px
.date-device
    height: 370px
    overflow: auto
    padding: 8px
    // border: 1px solid #282729
    // .ctn
    //     padding: 8px
    //     height: 100%
    //     overflow: auto
</style>